// extracted by mini-css-extract-plugin
module.exports = {"link":"_9d2893d","sizeExtraSmall":"_44b06aa","sizeSmall":"_5e9c9f9","sizeMedium":"_64cb163","sizeLarge":"_33aa32c"};